<template>
  <popup-modal ref="popup">
    <DialogCloseButton :close-method="closeDialog" />

    <!--STEP 1-->
    <div v-if="showStep1">
      <h2 class="font-weight-bold title content">
        {{ $t('LEAVE_MODAL.STEPPER_MODAL.STEP_1.TITLE') }}
      </h2>

      <v-row class="mt-2 content">
        <v-col cols="5">
          <div class="d-flex justify-center mb-2">
            <p class="sub-title">1/2</p>
          </div>
          <v-progress-linear model-value="50" color="#559a1b" />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-btn class="boom-button dialog-button" variant="outlined" @click="saveAndLeave">
            {{ $t('LEAVE_MODAL.STEPPER_MODAL.STEP_1.VALIDATION_BUTTON') }}
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn class="boom-button-back dialog-button" variant="outlined" @click="goStepTwo">
            {{ $t('LEAVE_MODAL.STEPPER_MODAL.STEP_1.CANCEL_BUTTON') }}
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <!--STEP 2-->
    <div v-if="showStep1 === false">
      <h2 class="font-weight-bold title content">
        {{ $t('LEAVE_MODAL.STEPPER_MODAL.STEP_2.TITLE') }}
      </h2>

      <v-row class="mt-2 content">
        <v-col cols="5">
          <div class="d-flex justify-center mb-2">
            <p class="sub-title">2/2</p>
          </div>
          <v-progress-linear model-value="50" color="#559a1b" reverse />
        </v-col>
      </v-row>

      <v-row>
        <v-radio-group inline v-model="leaveReason">
          <v-col cols="6">
            <div>
              <v-radio
                :label="$t('LEAVE_MODAL.STEPPER_MODAL.STEP_2.REASON.REPAIR_TOO_EXPENSIVE')"
                :value="LeaveReasonConstant.REPAIR_TOO_EXPENSIVE"
                color="#559a1b"
              >
              </v-radio>
            </div>
            <div>
              <v-radio
                :label="
                  $t('LEAVE_MODAL.STEPPER_MODAL.STEP_2.REASON.REPAIR_TOO_EXPENSIVE_AND_BUY_SAME')
                "
                :value="LeaveReasonConstant.REPAIR_TOO_EXPENSIVE_AND_BUY_SAME"
                color="#559a1b"
              >
              </v-radio>
            </div>
            <div>
              <v-radio
                :label="$t('LEAVE_MODAL.STEPPER_MODAL.STEP_2.REASON.NO_PACKAGE')"
                :value="LeaveReasonConstant.NO_PACKAGE"
                color="#559a1b"
              >
              </v-radio>
            </div>
          </v-col>
          <v-col cols="6">
            <div>
              <v-radio
                :label="
                  $t('LEAVE_MODAL.STEPPER_MODAL.STEP_2.REASON.REPAIR_TOO_EXPENSIVE_AND_BUY_OTHER')
                "
                :value="LeaveReasonConstant.REPAIR_TOO_EXPENSIVE_AND_BUY_OTHER"
                color="#559a1b"
              >
              </v-radio>
            </div>
            <div>
              <v-radio
                :label="$t('LEAVE_MODAL.STEPPER_MODAL.STEP_2.REASON.OTHER')"
                :value="LeaveReasonConstant.OTHER"
                color="#559a1b"
              >
              </v-radio>
            </div>
          </v-col>
        </v-radio-group>
      </v-row>

      <v-row class="step-two-recycling-container">
        <v-col>
          <v-row>
            <v-col class="step-two-title-container">
              <h2 class="title">{{ $t('LEAVE_MODAL.STEPPER_MODAL.STEP_2.RECYCLING.TITLE') }}</h2>
            </v-col>
          </v-row>
          <v-row v-if="buybackPrice">
            <v-col cols="12" class="d-flex justify-center step-two-message-container">
              <v-icon icon="mdi-percent-circle-outline" class="mr-1" />
              {{ $t('LEAVE_MODAL.STEPPER_MODAL.STEP_2.RECYCLING.BUYBACK_MESSAGE', buybackPrice) }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6" class="step-two-leave-button">
          <v-btn
            class="boom-button-back step-two-dialog-button"
            variant="outlined"
            @click="saveReasonAndLeave"
            :disabled="!leaveReason"
            :loading="loading"
          >
            {{ $t('COMMON.BUTTON.LEAVE') }}
          </v-btn>
        </v-col>
        <v-col cols="6" class="step-two-leave-button">
          <v-btn
            class="boom-button-back step-two-dialog-button"
            variant="outlined"
            @click="saveReasonAndRecycle"
            :disabled="!leaveReason"
            :loading="loading"
          >
            {{ $t('COMMON.BUTTON.RECYCLE') }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </popup-modal>
</template>

<script>
import PopupModal from '@/components/modal/PopupModal.vue'
import RepairFileService from '@/services/RepairFileService'
import ResponseConstant from '@/constants/responseConstant'
import LeaveReasonConstant from '@/constants/leaveReasonContant'
import { auth as $store } from '@/store/AuthModule'
import RecyclingReferentialService from '@/services/recyclingModule/RecyclingReferentialService'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'
import { handleResponseError } from '@/components/utils/globalFunction'

export default {
  name: 'LeaveStepperModal',
  computed: {
    LeaveReasonConstant() {
      return LeaveReasonConstant
    }
  },
  components: { DialogCloseButton, PopupModal },
  data() {
    return {
      showStep1: true,
      leaveReason: null,
      currentRepairFile: null,
      buybackPrice: 0,
      loading: false
    }
  },
  methods: {
    async show(opts = {}) {
      this.currentRepairFile = opts.currentRepairFile

      this.buybackPrice = await RecyclingReferentialService.getBuybackPriceByProductBoomerangId(
        this.currentRepairFile.product_boomerang_id
      )

      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    saveAndLeave() {
      this.$refs.popup.close()
      this.resolvePromise('saveAndLeave')
    },
    goStepTwo() {
      this.showStep1 = false
    },
    async saveReasonAndLeave() {
      this.loading = true
      try {
        const data = {
          repairFileId: this.currentRepairFile.technical_id,
          leaveReason: this.leaveReason,
          requesterCollaboratorId: $store.state.currentCollaborator.technical_id
        }

        await RepairFileService.saveLeaveReason(data)

        this.$refs.popup.close()
        this.resolvePromise('saveAndLeaveWithReason')
      } catch (error) {
        handleResponseError(error)
        if (error.response?.data && error.response.data.key in ResponseConstant) {
          this.setError(error.response.data.key)
        }
      } finally {
        this.loading = false
      }
    },
    async saveReasonAndRecycle() {
      this.loading = true
      try {
        const data = {
          repairFileId: this.currentRepairFile.technical_id,
          leaveReason: this.leaveReason,
          requesterCollaboratorId: $store.state.currentCollaborator.technical_id
        }

        await RepairFileService.saveLeaveReasonAndRecycle(data)

        this.$refs.popup.close()
        this.resolvePromise('saveAndLeaveWithReasonAndRecycle')
      } catch (error) {
        handleResponseError(error)
        if (error.response?.data && error.response.data.key in ResponseConstant) {
          this.setError(error.response.data.key)
        }
      } finally {
        this.loading = false
      }
    },
    closeDialog() {
      this.showStep1 = true
      this.leaveReason = null
      this.loading = false
      this.$refs.popup.close()
    },
    setError(key) {
      switch (key) {
        default:
          this.error = ''
      }
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.content {
  display: flex;
  justify-content: center;
}

.dialog-button {
  min-width: 100px;
  width: 100%;
}

.sub-title {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.step-two-leave-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
}

.step-two-dialog-button {
  min-width: 250px;
  width: 50%;
}

.step-two-recycling-container {
  background: #efefef;
  border-radius: 20px;
  padding: 20px;
  margin-bottom: 12px;
}

.step-two-title-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;

  .title {
    font-weight: bold;
  }
}

.step-two-message-container {
  font-size: large;
}

:deep(.v-btn__content) {
  white-space: normal !important;
}
</style>
